var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeavingTheRegion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_660_3436",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#ECEFF1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_660_3436)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1414 35C39.5636 38.0026 34.827 43.3101 33.6852 47.0527C33.0297 49.1673 33.7063 51.4298 35.2922 52.9734C37.7028 55.3205 42.8834 59.465 50.4956 61.0509C56.8392 62.3619 51.9335 65.005 46.7318 66.9715C43.0737 68.3459 39.2887 69.3821 35.4614 70.1221C20.6598 72.9767 -31.5265 84.67 6.76738 101.269C6.93655 101.332 7.12685 101.375 7.29601 101.375H82.5517C83.8627 101.375 84.3702 99.6831 83.2918 98.9642C76.9271 94.6928 67.3695 85.1564 85.4274 73.9494C108.116 59.8667 65.4241 50.8377 57.3889 49.6748C55.6973 49.421 54.048 48.9135 52.5678 48.0466C48.8674 45.8686 45.7802 41.4281 61.2585 35.0211H56.1414V35Z",
    fill: "#3A556A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4691 75.0705L65.9316 73.4634C68.1942 71.9833 69.2937 70.4185 69.3572 68.8749C69.4629 66.5067 67.1792 64.4556 66.418 63.9058L67.5598 62.9966C67.6867 63.0812 71.3448 65.3437 71.5351 68.8961C71.6408 71.3278 71.4294 72.6599 68.4691 75.0705Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9264 59.9514C59.0383 59.6976 52.3776 57.6466 51.3838 55.2783L53.1177 54.3479C53.752 55.4263 58.8903 57.7523 61.3643 58.3443L59.9264 59.9514Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4668 88.2436L41.8897 85.8331C52.1874 85.8965 58.0023 79.5529 58.0446 79.4895L59.8843 80.6313C59.6517 80.9062 53.4773 88.2647 41.4668 88.2436Z",
    fill: "#D5D6DB"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeavingTheRegion);
export default __webpack_public_path__ + "static/media/leavingTheRegion.ae5a51d93731a8f9725d8e88da17f38a.svg";
export { ForwardRef as ReactComponent };